import {
  SuvisiaciProces as SuvisiaciProcesGenerated,
  SuvisiaciProcesListApi,
} from 'indexer-frontend-ts-axios';
import apiConfiguration from '../../configuration/apiConfiguration';
import { indexerPrefixPath } from '../../configuration/apiConfigurationConstants';
import { ClientResponse } from '../../../model/ClientResponse';
import SuvisiaciProces from '../../../model/legislativnyMaterial/SuvisiaciProces';

const client = new SuvisiaciProcesListApi(apiConfiguration(indexerPrefixPath));

function map(suvisiaciProcesList: SuvisiaciProcesGenerated[]): SuvisiaciProces[] {
  return suvisiaciProcesList.map(suvisiaciProces => ({
    cisloLp: suvisiaciProces.iri,
    nazov: suvisiaciProces.menovka,
    cisloLpNazov: `${suvisiaciProces.iri} - ${suvisiaciProces.menovka}`,
  }));
}

function formatDopytQueryParam(dopyt: string): string {
  return dopyt ? `"${dopyt}"` : '';
}

// eslint-disable-next-line import/prefer-default-export
export const fetchSuvisiaciProcesList = async (
  dopyt?: string,
  limit?: number,
  headers?: object,
): Promise<ClientResponse<SuvisiaciProces[]>> => {
  const {
    data,
    status,
  } = await client.getSuvisiaciProcesList(formatDopytQueryParam(dopyt), 'hodnotaPola asc', limit, headers);
  return {
    data: map(data),
    responseCode: status,
  };
};
